import { render, staticRenderFns } from "./payment_group.vue?vue&type=template&id=8e390dc8&scoped=true"
import script from "./payment_group.vue?vue&type=script&lang=js"
export * from "./payment_group.vue?vue&type=script&lang=js"
import style0 from "./payment_group.vue?vue&type=style&index=0&id=8e390dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e390dc8",
  null
  
)

export default component.exports